import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * Sidebar Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Raised Sidebar
     */
    @Prop({ type: Boolean }) raised!: boolean;

    /**
     * Color of the sidebar
     */
    @Prop({ default: 'primary' }) color!: string;

    /**
     * User Info
     * Used Types: Dashboard
     */
    @Prop() user!: {[k: string]: any};

    /**
     * User Metadata
     * Used Types: Dashboard
     */
    @Prop() userMetadata!: {[k: string]: any};

    /**
     * Wallet Info
     * Used Types: Dashboard
     */
    @Prop() wallets!: object;

    /**
     * Navigation
     * Used Types: Dashboard
     */
    @Prop() navigation!: Array<object>;

    /**
     * Avatar Width and Height
     */
    @Prop({ default: '64px' }) size!: string;

    /**
     * User Contact Info
     * To show in the sidebar, bottom of the user name
     */
    @Prop({ default: 'mobile' }) userContactToShow!: string;

    /**
     * Wallet Box Info
     * `{
     * `  label: '',
     * `  size: '',
     * `  icon: {
     * `    name: '',
     * `    prefix: '',
     * `    library: '',
     * `  }
     * `  link: {
     * `    name: '',
     * `    params: {},
     * `    query: {},
     * `  }
     * `}
     */
    @Prop() walletChargeButton!: object;
}
